import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import $ from "jquery";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";
import SisSelect from "store/sis/component/SisSelect";

import "store/sis/css/ol.scss";

import "./weather.scss";

class Weather extends Component {
	state = {
		locName: "",
		mTemp: {},
		data: [],
	};

	componentDidMount() {
		const { LayoutActions } = this.props;

		LayoutActions.setModal({
			id: "weatherModal",
			target: this,
		});
	}

	setData = (locName, mTemp, data) => {
		this.setState({
			locName,
			mTemp,
			data,
		});
	};

	render() {
		return (
			<div>
				<SisModal
					id={this.props.id}
					title="상세 기상정보"
					draggable
					contents={
						<div className="weatherWrap">
							<div className="posWrap">
								<span className="headerLabel" style={{ width: "30%" }}>
									지점
								</span>
								<span className="value">{this.state.locName}</span>
							</div>

							<div className="contentsWrap">
								<div className="itemsWrap">
									<div className="item minMax">
										<div id="highWrap" className="weather">
											<span>최고온도</span>
											<div className="line"></div>
											<span>{`${this.state.mTemp ? this.state.mTemp.maxTemp : "-"} ℃`}</span>
										</div>
										<div id="lowWrap" className="weather">
											<span>최저온도</span>
											<div className="line"></div>
											<span>{`${this.state.mTemp ? this.state.mTemp.minTemp : "-"} ℃`}</span>
										</div>
									</div>
									{this.state.data.map((item, idx) => {
										const fcstTime = item.fcstTime.substring(0, 2) + ":" + item.fcstTime.substring(2, 4);
										let vec = "";
										const temp = Math.sqrt(Math.abs(Math.pow(parseFloat(item.uuu), 2)) + Math.abs(Math.pow(parseFloat(item.vvv), 2))).toFixed(2);

										if (item.vec > 0 && item.vec < 90) {
											vec = "북동";
										} else if (item.vec > 90 && item.vec < 180) {
											vec = "남동";
										} else if (item.vec > 180 && item.vec < 270) {
											vec = "남서";
										} else if (item.vec > 270 && item.vec < 360) {
											vec = "북서";
										} else if (item.vec === 0) {
											vec = "북";
										} else if (item.vec === 90) {
											vec = "동";
										} else if (item.vec === 180) {
											vec = "남";
										} else if (item.vec === 270) {
											vec = "서";
										}

										return (
											<div className="item" key={idx}>
												<div className="imageWrap">
													<span className="time">{fcstTime}</span>
													<div className={`image a${item.sky}`}></div>
												</div>
												<div className="tableWrap">
													<table>
														<caption>기온, 풍향/풍속, 습도, 강수량</caption>
														<tbody>
															<tr>
																<th>기온</th>
																<td>{`${item.tmp} ℃`}</td>
															</tr>
															<tr>
																<th>풍향/풍속</th>
																<td>{`${vec} ${temp}m/s`}</td>
															</tr>
															<tr>
																<th>습도</th>
																<td>{`${item.reh === "" ? "-" : item.reh} %`}</td>
															</tr>
															<tr>
																<th>강수확률</th>
																<td>{`${item.pop === "" ? "-" : item.pop} %`}</td>
															</tr>
															<tr>
																<th>강수량</th>
																<td>{item.pcp === "" ? "-" : item.pcp}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					}
				/>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(Weather);
